<template>
  <div
    class="custom-message-component-sizedBox"
    :style="{...style }"
    @click="clickHandle"
  >
    <slot />
  </div>
</template>

<script lang="ts" >
import { CustomMessageSizedBoxComponent } from '_c/typings/model/chat/text-node';
import { pushUrl, getWidth } from '@/business/chat/custom-message-util';
import { defineComponent, PropType, toRaw } from 'vue';

export default defineComponent({
  name: 'CustomMessageSizedBox',
  props: {
    attr: {
      type: Object as PropType<CustomMessageSizedBoxComponent>,
      required: true,
    },
  },
  setup(props) {
    let scale = 1;
    const attr = toRaw(props.attr);
    if (attr.scale) {
      scale = attr.scale;
    }
    function clickHandle(e: Event): void {
      if (attr.onClick) {
        e.stopPropagation();
        pushUrl(attr.onClick, attr.reportData);
      }
    }
    const width = getWidth(props.attr.width, scale);
    const style = {
      width,
      height: attr.height ? `${(attr.height * scale) / 2}px` : '',
    };


    return {
      clickHandle, style,
    };
  },

});


</script>

